import React from 'react';

import SectionNewsletter from '../../../containers/LandingPage/SectionNewsletter';
import { withBaseComponent } from '../hoc/withBaseComponent';

/**
 * Storyblok Newsletter component.
 * @returns {React.ReactNode}
 */

const StoryblokNewsletter = () => {
  return <SectionNewsletter googleCaptchaElementId="storyblokNewsLetterElementId" />;
};

export default withBaseComponent(StoryblokNewsletter);
